"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlag = void 0;
/**
 * Enum containing all LaunchDarkly feature flags in use.
 *
 * Flag keys are important and non-reusable unique identifiers.
 * The keys must provide information about the purpose and scope of a flag.
 *
 * Suggested naming convention can be found here: https://launchdarkly.com/docs/guides/flags/flag-conventions#flag-kind-examples
 * Keys must be in kebab-case.
 */
var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["EXPERIMENT_WATSON_SEARCH_RESOURCE_CENTER"] = "experiment-watson-search-resource-center";
    FeatureFlag["RELEASE_APWG_API_GENERATED_SCHEDULER_LINK"] = "release-apwg-api-generated-scheduler-link";
    /** @deprecated This flag is no longer in use */
    FeatureFlag["AMP_IS_ELEMENT_VISIBLE"] = "amp-isElementVisible";
    /** @deprecated This flag is no longer in use */
    FeatureFlag["RELEASE_ADOBE_ALLOY_PERSONALIZATION"] = "release-adobe-alloy-personalization";
    /** @deprecated This flag is no longer in use */
    FeatureFlag["RELEASE_SEARCH_SPELLING_SUGGESTIONS"] = "release-search-spelling-suggestion";
    /** @deprecated This flag is no longer in use */
    FeatureFlag["RELEASE_EVOLVED_FACETS"] = "release-evolved-facets";
    /** @deprecated This flag is no longer in use */
    FeatureFlag["RELEASE_NEW_BRAND_ICONS"] = "release-new-brand-icons";
    /** @deprecated This flag is no longer in use */
    FeatureFlag["RELEASE_RESOURCE_CENTER_SUB_FILTERS"] = "release-resource-center-sub-filters";
})(FeatureFlag || (exports.FeatureFlag = FeatureFlag = {}));
